import * as React from 'react';
import { getBaseUrl } from '@/redux/modules/config';
import { getCatalogTitle } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { useAppSelector } from '@/redux/hooks';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import PageHeaderMeta from '@liveauctioneers/caterwaul-components/lib/PageHeaderMeta/PageHeaderMeta';
import useAddNotificationCountToTitle from '@/hooks/useAddNotificationCountToTitle';

type Props = {
    catalogId: number;
};

const AuctionVideoPageHeaderMeta = ({ catalogId }: Props) => {
    const { formatMessage } = useIntl();
    const baseUrl = useAppSelector(getBaseUrl);
    const title = useAppSelector((state) => getCatalogTitle(state, catalogId));
    const pageTitle = useAddNotificationCountToTitle(formatMessage({ id: 'bidding_console.video.title' }, { title }));
    const description = formatMessage({ id: 'bidding_console.video.description' }, { title });
    const canonical = `${baseUrl}/video/${catalogId}`;

    return (
        <PageHeaderMeta
            canonical={canonical}
            description={description}
            title={pageTitle}
        />
    );
};

export default AuctionVideoPageHeaderMeta;
